import { Components, Theme } from '@mui/material/styles'

export const MuiButton: Components<Theme>['MuiButton'] = {
  defaultProps: {
    disableElevation: true,
  },

  styleOverrides: {
    root: {
      textTransform: 'none',
    },

    outlined: ({ theme }) => ({
      '&.MuiButton-colorPrimary': {
        color: theme.palette.text.primary,
      },
    }),

    text: ({ theme }) => ({
      '&.MuiButton-colorPrimary': {
        color: theme.palette.text.primary,
      },
    }),

    sizeSmall: {
      padding: '6px 10px',
    },

    sizeMedium: {
      padding: '8px 16px',
    },

    sizeLarge: {
      padding: '12px 22px',
      fontSize: '16px',
      fontWeight: 600,
    },

    outlinedSizeSmall: {
      padding: '5px 9px',
    },

    outlinedSizeMedium: {
      padding: '7px 15px',
    },

    outlinedSizeLarge: {
      padding: '11px 21px',
    },
  },
}
